// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 1782
// module chunks = 0